var options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

export const formatDate = (dt) =>
  new Date(dt).toLocaleDateString("en-US", options);
